import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class Configurations extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "monitoring-configurations";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(configurations) {
        try {
            await this.$post(this.baseURL, configurations);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(configurations) {
        try {
            await this.$put(`${this.baseURL}/${configurations.id}`, configurations);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(configurationsId) {
        try {
            await this.$delete(`${this.baseURL}/${configurationsId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async setActive(configurationsId, isActive) {
        try {
            await this.$put(`monitoring-configurations-activity/${configurationsId}`, isActive);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
